var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1157,
    height: 980,
    viewBox: "0 0 1157 980",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M1046.46 555.822L788.529 570.449L653.338 980H582.185L677.987 585.075L390.58 702.09L685.357 497.313L994.873 468.06L1031.72 409.552L818.006 329.104L810.637 277.91L626.401 204.776L464.274 380.299H626.401L257.93 650.896L0 848.358V760.597L272.669 482.687H147.389L604.293 0L663.248 124.328L906.439 215.718V263.285L1157 365.673L1046.46 555.822Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTransparent);
export default __webpack_public_path__ + "static/media/logo_transparent.73de3810eb3c40419e26fde3a0eacb94.svg";
export { ForwardRef as ReactComponent };